import el from "@cypherpotato/el"
import { Icon } from "../components/icon";

function getToastContainer() {
    var toastContainer = document.querySelector("#toast-container");
    if (!toastContainer) {
        toastContainer = el("div#toast-container");
        document.body.appendChild(toastContainer);
    }

    return toastContainer;
}

function displayToast(message, type) {
    const toast = el(".toast-message",
        {
            classList: [type]
        },
        el("div", message)
    );

    const container = getToastContainer();
    container.appendChild(toast);

    setTimeout(() => {
        toast.classList.add("visible");
    }, 10);
    setTimeout(() => {
        toast.classList.remove("visible");
    }, 5000);
    setTimeout(() => {
        toast.remove();
    }, 6000);
}

export function showErrorToast(message) {
    displayToast(el.fragment(
        Icon("alert-line"),
        message
    ), "toast-error");
}

export function showSuccessToast(message) {
    displayToast(el.fragment(
        Icon("check-line"),
        message
    ), "toast-success");
}